import React from "react";
import NavBar from "../layout/NavBar";
import asset1 from "../assets/asset1.svg";
import stars from "../assets/stars.svg";

const Hero = () => {
  return (
    <>
      <NavBar />
      <div dir="rtl" className="flex flex-col items-center">
        <div className="flex flex-col md:flex-row items-center justify-between rounded-3xl md:px-20 p-10 w-[90%] bg-[#81B9DE] gap-5">

          {/* Text Section */}
          <div className="flex flex-col md:w-1/3 md:gap-10 gap-5">
            <div className="flex flex-wrap text-start">
              <h1 className="text-3xl font-bold text-start">
                <span className="text-blue-800 ml-2">{"التعلم "}</span>
                {"هو المفتاح الذي يفتح لك أبواب المستقبل"}
              </h1>
            </div>
            <p className="text-xl">
              انضموا إلينا اليوم وابدأوا رحلتكم نحو التميز مع سلامات، المستقبل بين يديكم.
            </p>
            <div className="flex flex-row items-center gap-4 md:text-xl ">
              <button className="text-blue-800 border-2 rounded-full border-blue-800 px-5 py-2">
                دعنا نبدأ
              </button>
              <button className="text-white bg-blue-800 rounded-full px-5 py-2">
                اكتشف الآن
              </button>
            </div>
          </div>

          {/* Image Section */}
          <div className="md:w-1/2 flex flex-col justify-center">
            <img
              src={stars}
              alt="Hero illustration"
              className="w-24 h-24 hidden md:flex md:absolute top-1/3 left-1/2"
            />
            <img src={asset1} alt="Hero illustration" className="w-full h-auto" />
          </div>

          {/* Stats Section */}
          <div className="flex md:flex-col bg-[#373F9626] p-4 rounded-xl text-center gap-5">
            <div className="flex flex-col">
              <span className="text-xl text-blue-800">+500</span>
              <span className="text-xl text-white ml-1">الطلاب</span>
            </div>
            <div className="flex flex-col">

              <span className="text-xl text-blue-800">+110</span>
              <span className="text-xl text-white ml-1">المواد</span>
            </div>
            <div className=" flex flex-col">
              <span className="text-xl text-blue-800">+130</span>
              <span className="text-xl text-white ml-1">الدروس</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
